import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Shift } from '../shift';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ShiftsService } from '../shifts.service';
import { FsService } from '../fs.service';
import { Supervisor } from '../supervisor';
import { PositionService } from '../position.service';
import { Position } from '../position';
import { MatDialog } from '@angular/material';
import { AddFsComponent } from './add-fs/add-fs.component';
import { PositionAssignmentsService } from '../position-assignments.service';
import { Assignment } from '../assignment';
import { Validations } from '../validations';
import { userInfo } from 'os';
import { getShiftPriorityOrder } from '../ShiftInfo';
import { removeTimeFromWorkArea } from 'src/utils';

@Component({
  selector: 'app-shifts',
  templateUrl: './shifts.component.html',
  styleUrls: ['./shifts.component.scss']
})
export class ShiftsComponent implements OnInit {

  site = '';
  siteId = '';
  currDate = new Date();
  // date = '2018-05-25';
  numCols: any = 3;
  shiftsHolder: Shift[] = [];
  shifts: Shift[] = [];
  supervisors: Supervisor[] = [];
  positions: Position[] = [];
  clearance = localStorage.getItem('clearance');
  refreshTimer: any;
  validations: Validations[] = [];
  isDataAvailable = false;

  constructor(
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private shiftsService: ShiftsService,
    private fsService: FsService,
    private positionService: PositionService,
    private positionAssignmentsService: PositionAssignmentsService,
    private location: Location,
    public dialog: MatDialog,
    private router: Router
  ) {

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      if (localStorage.getItem('token') === null) {
        this.router.navigate(['/login']);
      }
      if (localStorage.getItem('selectedDate') !== null) {
        this.currDate = new Date(localStorage.getItem('selectedDate'));
      } else {
        localStorage.setItem('selectedDate', this.getFormattedDate(this.currDate));
      }
      localStorage.removeItem('branchCode');
      this.adjustSize();

      this.site = this.route.snapshot.paramMap.get('site');
      this.site = this.site.replace(/#2F/g, '/');
      if (this.site) {
        this.site = this.site;
      } else {
        this.site = '';
      }

      // this.getSupervisors(this.site);
      this.getShifts(this.site);
      this.refreshTimer = setInterval(() => {
        this.getSupervisors(this.site);
        this.getShifts(this.site);
      }, 1000 * 60 * 10);
    });

    /*if (localStorage.getItem('token') === null) {
      this.router.navigate(['/login']);
    }
    if (localStorage.getItem('selectedDate') !== null) {
      this.currDate = new Date(localStorage.getItem('selectedDate'));
    }
    localStorage.removeItem('branchCode');
    this.adjustSize();

    this.site = this.route.snapshot.paramMap.get('site');
    this.site = this.site.replace(/#2F/g, '/');
    if (this.site) {
      this.site = this.site;
    } else {
      this.site = '';
    }

    // this.getSupervisors(this.site);
    this.getShifts(this.site);
    this.refreshTimer = setInterval(() => {
      this.getSupervisors(this.site);
      this.getShifts(this.site);
    }, 1000 * 60 * 10);*/
  }

  getSupervisors(site: string) {
    this.fsService.getSupervisors(site)
    .subscribe((data) => {
        this.compileSupervisorData(data);
      });
  }

  compileSupervisorData(data: any) {
    this.supervisors = [];
    for (const item of data) {
      const supervisor = new Supervisor;
      supervisor.itemId = item.id;
      supervisor.id = item.inspectorId;
      supervisor.email = item.email;
      supervisor.name = item.lastName + ', ' + item.firstName;
      supervisor.shift = item.shift;
      supervisor.c1label = item.c1label;
      supervisor.c2label = item.c2label;
      supervisor.c3label = item.c3label;
      supervisor.c4label = item.c4label;
      supervisor.c5label = item.c5label;
      supervisor.c6label = item.c6label;
      supervisor.amStartH = item.amStartH;
      supervisor.amStartM = item.amStartM;
      supervisor.amEndH = item.amEndH;
      supervisor.amEndM = item.amEndM;
      supervisor.pmStartH = item.pmStartH;
      supervisor.pmStartM = item.pmStartM;
      supervisor.pmEndH = item.pmEndH;
      supervisor.pmEndM = item.pmEndM;
      supervisor.mnStartH = item.mnStartH;
      supervisor.mnStartM = item.mnStartM;
      supervisor.mnEndH = item.mnEndH;
      supervisor.mnEndM = item.mnEndM;
      supervisor.c4StartH = item.c4StartH;
      supervisor.c4StartM = item.c4StartM;
      supervisor.c4EndH = item.c4EndH;
      supervisor.c4EndM = item.c4EndM;
      supervisor.c5StartH = item.c5StartH;
      supervisor.c5StartM = item.c5StartM;
      supervisor.c5EndH = item.c5EndH;
      supervisor.c5EndM = item.c5EndM;
      supervisor.c6StartH = item.c6StartH;
      supervisor.c6StartM = item.c6StartM;
      supervisor.c6EndH = item.c6EndH;
      supervisor.c6EndM = item.c6EndM;
      supervisor.isMon = item.isMon;
      supervisor.isTues = item.isTues;
      supervisor.isWed = item.isWed;
      supervisor.isThurs = item.isThurs;
      supervisor.isFri = item.isFri;
      supervisor.isSat = item.isSat;
      supervisor.isSun = item.isSun;
      supervisor.agencyRequirements = item.agencyRequirements;
      supervisor.phone = item.phone;
      supervisor.leaderTitle = item.leaderTitle;
      if (item.streetName !== '') {
        supervisor.siteAddress = item.streetNumber + ' ' + item.streetName + ' ' + item.city
          + ', ' + item.state + ', ' + item.country;
      } else {
        supervisor.siteAddress = '';
      }
      this.supervisors.push(supervisor);
    }
  }

  getShifts(site: string) {
    this.shiftsService.getShifts(site)
      .subscribe((data) => {
        if (data && data[0]) {
            this.siteId = data[0].site;
            localStorage.setItem('siteId', this.siteId);
            this.compileShiftsData(data);
        }
        this.getValidations(this.siteId, this.currDate.toISOString().substr(0, 10));
      });
  }

  getValidations(site: String, date: String) {
    this.shiftsService.getValidations(site, date)
      .subscribe((data) => {
        if (data && data[0]) {
            this.setValidations(data);
        }
      });
  }

  setValidations(data: any) {
    for (const shift of this.shiftsHolder) {
      for (const val of data) {
        if (shift.name === val.shift) {
          shift.isCovid = 1;
          shift.covidId = val.id;
        }
      }
    }
  }

  compileShiftsData(data: any) {
    this.getPositions(this.site, this.getFormattedDate(this.currDate));
    this.shifts = [];
    this.shiftsHolder = [];
    for (const item of data) {
      const shift = new Shift;
      shift.name = item.shift;
      shift.start = item.startTime;
      shift.end = item.endTime;
      this.shiftsHolder.push(shift);
    }
  }

  getPositions(site: string, date: string) {
    this.positionService.getPositions(site, date)
      .subscribe((data) => {
        this.compilePositionsData(data);
      });
  }

  compilePositionsData(data: any) {
    this.positions = [];
    for (const shift of this.shiftsHolder) {
      this.positions = [];
      for (const item of data) {
        if (shift.name === item.shift) {
          const position = new Position;
          position.id = item.id;
          position.name = '';
          position.start = item.startTime;
          position.end = item.endTime;
          position.requirement = item.requirement;
          position.workArea = item.workArea ? removeTimeFromWorkArea(item.workArea) : item.workArea;
          position.isRequested = 0;
          this.positions.push(position);
        } else {
          let shiftExists = false;
          for (const s of this.shiftsHolder) {
            if (s.name === item.shift) {
              shiftExists = true;
            }
          }
          if (!shiftExists) {
            const tempShift: Shift = new Shift;
            tempShift.name = item.shift;
            tempShift.positions = [];
            tempShift.isGenerated = 1;
            this.shiftsHolder.push(tempShift);
          }
        }
      }
      shift.positions = this.positions;
      this.shifts.push(shift);
    }
    this.getPositionAssignments(this.site, this.getFormattedDate(this.currDate));
  }

  getPositionAssignments(site: string, date: string) {
    this.positionAssignmentsService.getPositionAssignments(site, date)
      .subscribe((data) => {
        this.compilePositionAssignmentsData(data);
        this.getConfirmedShifts();
      });
  }

  getConfirmedShifts() {
    const tempDate: Date = new Date();
    tempDate.setDate(this.currDate.getDate() + 1);
    this.positionAssignmentsService.getFutureAssignments(this.formatDate(tempDate))
      .subscribe((data) => {
        this.checkForConfirmed(data);
      });
  }

  checkForConfirmed(data: any) {
    for (const shifts of this.shifts) {
      for (const pos of shifts.positions) {
        for (const asgn of pos.assignments) {
          for (const d of data) {
            if (d.inspectorId === asgn.inspectorId) {
              pos.isConfirmed = true;
            }
          }
        }
      }
    }
    this.isDataAvailable = true;
  }

  compilePositionAssignmentsData(data: any) {
    for (const shift of this.shiftsHolder) {
      for (const position of shift.positions) {
        for (const item of data) {
          if (item.positionId === position.id) {
            const assignment = new Assignment;
            assignment.id = item.id;
            assignment.positionId = item.positionId;
            assignment.type = item.type;
            assignment.inspectorId = item.inspectorId;
            assignment.agencyId = item.agencyId;
            assignment.inspectorName = item.lastName + ', ' + item.firstName;
            assignment.agencyName = item.name;
            assignment.inspPhone = item.phone;
            assignment.inspEmail = item.email;
            assignment.inspAgency = item.affiliateName;
            assignment.isRequested = item.isRequested;
            assignment.covid = item.covid;
            assignment.onSite = item.onSite;
            assignment.covidRecord = item.covidRecord;
            assignment.title = item.title;
            position.assignments.push(assignment);
          }
        }
      }
    }
    this.getSupervisors(this.site);
    this.displayData();
  }

  displayData() {
    for (const shift of this.shiftsHolder) {
      for (const position of shift.positions) {
        if (position.assignments.length === 0) {
          // Position has no assignments
          position.name = 'EMPTY';
        } else if (position.assignments.length === 1) {
          // Position is assigned to one entity
          if (position.assignments[0].type === 0) {
            // Position assigned to inspector (status 1)
            if (position.assignments[0].isRequested === 1) {
              // Inspector is requested (status 1)
              position.name = position.assignments[0].inspectorName;
              position.isRequested = 1;
              position.status = 1;
            } else {
              // Inspector is confirmed (status 1)
              position.name = position.assignments[0].inspectorName;
              position.status = 1;
            }
          } else {
            // Position is assigned to Agency (status 2)
            position.name = position.assignments[0].agencyName;
            position.status = 2;
          }
        } else {
          let isInsp, isAg = 0;
          for (const item of position.assignments) {
            // Agencies are allowed to have multi assignments, so check to make sure there aren't inspector assignments
            if (item.type === 0) {
              // At least one inspector
              isInsp = 1;
            } else {
              // At least one agency
              isAg = 1;
            }
          }
          if (isInsp === 1 && isAg === 0) {
            // Multiple item contains only inspectors
            let i = 0;
            for (const item of position.assignments) {
              if (i === 0) {
                // Update item for first in array
                i++;
                position.name = position.assignments[0].inspectorName;
                position.status = 1;
                position.isRequested = position.assignments[0].isRequested;
              } else {
                // Create new item for subsequent overflow positions
                const newPosition: Position = new Position;
                newPosition.id = position.id;
                newPosition.isOverflow = 1;
                newPosition.start = position.start;
                newPosition.end = position.end;
                newPosition.name = item.inspectorName;
                newPosition.status = 1;
                newPosition.isRequested = item.isRequested;
                newPosition.assignments.push(item);
                shift.positions.push(newPosition);
              }
            }
          } else if (isInsp === 0 && isAg === 1) {
            // Multiple item contains only agencies
            position.isMulti = 1;
            position.status = 3;
            position.name = 'Multiple Agencies';
            for (const item of position.assignments) {
              position.hoverText += item.agencyName + '\n';
            }
            position.hoverText = position.hoverText.substring(0, position.hoverText.length - 2);
          } else {
            // Multiple item contains inspectors and agencies
            let i = 0;
            for (const item of position.assignments) {
              if (i === 0) {
                i++;
                position.name = position.assignments[0].agencyName;
                position.status = 2;
                position.isSplitMulti = 1;
              } else {
                if (item.type === 0) {
                  if (position.isMulti === 1) {
                    position.hoverText = position.hoverText.substring(0, position.hoverText.length - 2);
                  }
                  const newPosition: Position = new Position;
                  newPosition.id = position.id;
                  newPosition.isOverflow = 1;
                  newPosition.start = position.start;
                  newPosition.end = position.end;
                  newPosition.name = item.inspectorName;
                  newPosition.status = 1;
                  newPosition.assignments.push(item);
                  shift.positions.push(newPosition);
                } else {
                  if (i === 1) {
                    position.hoverText += position.assignments[0].agencyName + '\n';
                    i++;
                  }
                  position.isMulti = 1;
                  position.status = 4;
                  position.name = 'Multiple Agencies';
                  position.hoverText += item.agencyName + '\n';
                }
              }
            }
          }
        }
        position.dataLoaded = 1;
        for (const a1 of position.assignments) {
          for (const a2 of position.assignments) {
            if (a1.id !== a2.id && a1.positionId === a2.positionId) {
              position.isMulti = 1;
            }
          }
        }
      }
      shift.positions.sort(this.compare);
    }
  }

  compare(a, b) {
    if (a.name === 'EMPTY') {
      return 1;
    } else if (a.name < b.name) {
      return -1;
    } else {
      return 1;
    }
  }

  goBack(): void {
    this.location.back();
  }

  adjustSize(  ) {
    const element = window.innerWidth;
    this.numCols = 1;
    /* if (element < 1100) {
      this.numCols = 1;
    } else if (element < 1600) {
      this.numCols = 2;
    } else {
      this.numCols = 3;
    } */
  }

  dateChanged(t: any) {
    this.currDate = t.value;
    localStorage.setItem('selectedDate', t.value);
    this.refreshData();
  }

  dateUpdated() {
    this.refreshData();
  }

  getFormattedDate( dt: Date ): string {
    let m: any = dt.getMonth() + 1;
    m = (m < 10) ? '0' + m.toString() : m.toString();
    let d: any = dt.getDate();
    d = (d < 10) ? '0' + d.toString() : d.toString();

    return dt.getFullYear().toString() + '-' + m.toString() + '-' + d.toString();
  }

  refreshData() {
    this.shifts = [];
    this.shiftsHolder = [];
    this.positions = [];
    this.getSupervisors(this.site);
    this.getShifts(this.site);
  }

  addFsClicked() {
    this.dialog.open(AddFsComponent, {
      width: '80%',
      autoFocus: true,
      data: {
        site: this.site,
        siteId: this.siteId
      }
    })
    .afterClosed()
    .subscribe(({ supervisor }) => {
      // this.refreshData();
      if (supervisor) {
        this.supervisors.push(supervisor);
      }
    });
  }

  formatDate(date: Date) {
    const yr: any = date.getFullYear();
    let mnth: any = date.getMonth() + 1;
    let day: any = date.getDate();

    if (mnth < 10) { mnth = '0' + mnth; }
    if (day < 10) { day = '0' + day; }

    return yr + '-' + mnth + '-' + day;
  }

  sortShifts(a: Shift, b: Shift) {
    const priorityA = getShiftPriorityOrder(a.name);
    const priorityB = getShiftPriorityOrder(b.name);

    if (priorityA > priorityB) {
      return 1;
    }

    if (priorityA < priorityB) {
      return -1;
    }

    return 0;
  }

}
